const Agriculturedata = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Fasal Bima Yojna",
        discription:"The scheme is mandatory for farmers who have taken institutional loans from banks. It’s optional for farmers who have not taken institutional credit.",
        launchDate: "April 2016",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "National Agriculture Market (NAM)",
    discription:"The National Agriculture Market (NAM) is a pan-India electronic trading portal, which links the existing Agricultural Produce Market Committee (APMC) mandis across the country to form a unified national market for agricultural commodities.",
    launchDate: "14 April 2016",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "National Food Security Mission(NFSM)",
    discription:"The objectives was to increase the production of rice, wheat and pulses. The Mission is being continued during 12th Five Year Plan with new targets of additional production of food grains of 25 million tons of food grains",
    launchDate: "October",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "National Mission on Oilseeds and Oil Palm (NMOOP)",
        discription:"National Mission on Oilseeds and Oil Palm (NMOOP) is under implementation since 2014-15 in 27 states including North-Eastern States for increasing production and productivity of oilseeds including area expansion of oil palm.",
        launchDate: "write",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Misson for Integrated Development of Horticulture",
    discription:"Mission for Integrated Development of Horticulture (MIDH) has been launched for the holistic development of horticulture in the country since 2014 – 15. ",
    launchDate: "write", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "National  Initiative on Climate Resilient Agriculture",
    discription:"National Initiative on Climate Resilient Agriculture was launched in the year 2011 by Indian Council on Agricultural Research (ICAR) ",
    launchDate: "Year 2011",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "National Dairy Plan",
discription:"It is a Central Sector Scheme .Phase I is from 2011-12 to 2018-19.",
launchDate: "Year 2011-12",
AnualFund: "12345"},


{   id : "8",
schemeName: "National Mission for Sustainable Agriculture",
discription:"National Mission for Sustainable Agriculture (NMSA) has been formulated for enhancing agricultural productivity especially in rainfed areas focusing on integrated farming, water use efficiency, soil health management and synergizing resource conservation.",
launchDate: "Year 2014-15",
AnualFund: "12345"},


{   id : "9",
schemeName: "Rashtriya Krishi Vikas Yojna",
discription:"The scheme is launched to incentivize the states to increase their investment in Agriculture.",
launchDate: " Year 2007",
AnualFund: "12345"},

{   id : "10",
schemeName: "Paramparagat krishi Vikas Yojna",
discription:"“Paramparagat Krishi Vikas Yojana” is an elaborated component of Soil Health Management (SHM) of major project National Mission of Sustainable Agriculture (NMSA).",
launchDate: " Year 2015-16",
AnualFund: "12345"},


{   id : "11",
schemeName: "Pradhan Mantri Krishi Sinchai Yojna",
discription:"The overreaching vision of Pradhan Mantri Krishi Sinchayee Yojana (PMKSY) is to ensure access to some means of protective irrigation to all agricultural farms in the country, to produce ‘per drop more crop’, thus bringing much desired rural prosperity.",
launchDate: " 1 July 2015",
AnualFund: "12345"},


{   id : "12",
schemeName: "Soil Health Card Scheme",
discription:"‘Soil Health Card’ Scheme has been introduced to assist State Governments to issue soil health cards to all farmers in the country.",
launchDate: "19 February 2015",
AnualFund: "12345"},

{   id : "13",
schemeName: "Minimum Support Price",
discription:"Minimum Support Price (MSP) is a form of market intervention by the Government of India to insure agricultural producers against any sharp fall in farm prices.",
launchDate: " Year 1966-67",
AnualFund: "12345"},


{   id : "14",
schemeName: "Market Intervention Scheme (MIS)",
discription:"The Scheme is implemented when there is at least 10% increase in production or 10% decrease in the ruling rates over the previous normal year",
launchDate: " Year 1983",
AnualFund: "12345"},



]
export default Agriculturedata;